module.exports = __webpack_public_path__ + "static/columbus-medicine-8276ea01a6fac2b4cd2d2cc7b981e06c.png";